import config from '../config';
import axios from "axios";

export function createAPI ({ config, version }) {
	if (false){	
		axios.interceptors.response.use(function (response) {
			console.log('RRRR : ', response);
			var r = JSON.stringify(response);
			r.replace('Wrong','Calah');
			return JSON.parse(r);
		}, function (error) {
			// var e;
			// if(error.response){
			// 	e = JSON.stringify(error.response);
			// }
			// console.log('EEEE : ', e);
			// Any status codes that falls outside the range of 2xx cause this function to trigger
			// e.replace('Wrong','Calah');
			// Do something with response error
			return Promise.reject(error);
		});
	}
	return axios.create(config);
}


// WEBPACK FOOTER //
// src/api/create-api-client.js